import React, { Component } from 'react';
import { Button, Popconfirm, Tooltip, Space, Table, Spin, PageHeader, Layout, message, Typography } from 'antd'
import axios from 'axios';

//Componentes
import { IconDelete, IconEdit, IconArrowBack } from '../../Widgets/Iconos';
import FloatingButton from "../../Widgets/Floating Button/FloatingButton";
import ModalAlmacenProducto from "./ModalAlmacenProducto";


const { Text } = Typography;
const { Content } = Layout;

/**
 * @export
 * @class Productos
 * @extends {Component}
 * @description Vista de Productos
 */
export default class AlmacenProductos extends Component {

    back = () => {
       this.props.history.goBack();
    }

    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            modalVisible: false,
            almacen_id: this.props.match.params.almacen_id,
            inventario_id: this.props.match.params.inventario_id,
            almacen_producto_id: undefined,
            almacen: {
                direccion: ''
            },


            productos: [],
            limit: 10,
            page: 1,
            total: 0,
        }
    }

    componentDidMount() {
        //Mostrar input superior de busqueda 
        //Para acceder al valor del input = this.props.search
        this.props.updateFilterSearch(true);

        axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token');
        this.getAlmacen()
        this.getAlmacenProductos()

    }


    /**
     * @memberof AlmacenProductos
     * @method getAlmacen
     * @description Obtiene un almacen de la DB
     */
    getAlmacen = () => {
        axios.get('/almacenes/get', {
            params: {
                id: this.state.almacen_id
            }
        }).then(response => {
            console.log(response.data.data)
            this.setState({ almacen: response.data.data })

        }).catch(error => {
            message.error('Error al traer el almacen')
            console.log(error)
        })
    }

    /**
     * @memberof AlmacenProductos
     * @method getAlmacenProductos
     * @description Obtiene un almacen de la DB
     */
    getAlmacenProductos = ({

        page = this.state.productos.page,
        limit = this.state.productos.limit

    } = this.state.productos) => {

        this.setState(state => {
            state.productos.page = page;
            state.productos.limit = limit;
            return state;
        })
        return axios.get('/almacenes/productos/list-v2', {
            params: {
                almacen_id: this.state.almacen_id,
                page, 
                limit
            }
        }).then(response => {
            console.log('getAlmacenProductos', response.data)
            
            this.setState({
                productos: response.data.data,
                total: response.data.total,
                page: response.data.page,
                limit: response.data.limit
            })

        }).catch(error => {
            message.error(error?.response?.data?.message || 'Error al traer los productos del almacen')
            console.log(error)
        })
    }


    render() {

        const { almacenProductos } = this.state

        return (
            <Spin spinning={false}>
                <PageHeader
                    className="site-page-header custom-page-header"
                    title={ <div className="flex-left">
                                <Button ghost onClick={this.back} style={{ border: "none" }}>
                                    <IconArrowBack />
                                </Button>
                                {`Productos del Almacén - ${this.state.almacen.direccion}`}
                            </div>
                        }
                />
                <Content className="admin-content content-bg pd-1">
                    <Table
                        rowKey={record => record._id}
                        locale={{ emptyText: "Sin Productos en el Almacén" }}
                        dataSource={this.state.productos}
                        pagination={{
                            onChange: (page, limit) => {
                                this.getAlmacenProductos({ page, limit })
                            },
                            current: this.state.page,
                            total: this.state.total,
                            showSizeChanger: true,
                            pageSize: 10,
                            hideOnSinglePage: false,
                            position: ['bottomLeft'],
                        }}
                        columns={[
                            {
                                title: <Text>Producto <small> (Número Parte Fabricante) </small></Text>,
                                dataIndex: 'producto_id',
                                key: 'np_fabricante',
                                render: (text, record) => (
                                    <span>{record?.producto_id?.np_fabricante}</span>
                                ),
                            },
                            {
                                title: 'Cantidad',
                                dataIndex: 'cantidad',
                                key: 'cantidad',
                                align: 'right',
                                render: (text, record) => (
                                    <span>{record.cantidad?.toMoney(true) ?? 0}</span>
                                ),
                            },
                            {
                                title: 'Ubicación',
                                dataIndex: 'ubicacion',
                                key: 'ubicacion',
                            },
                            {
                                title: 'Acciones',
                                key: 'actions',
                                fixed: 'right',
                                width: '110px',
                                render: (text, record) => (
                                    <Space>
                                        <Tooltip title="Editar">
                                            <Button type="primary" icon={<IconEdit />} onClick={() => this.setState({
                                                modalAlmacenProducto: true,
                                                almacen_producto_id: record._id,
                                            })} />
                                        </Tooltip>

                                        <Popconfirm
                                            placement="topRight"
                                            title="¿Deseas eliminar este Producto  del Almacen?"
                                            onConfirm={() => axios.post('/almacenes/productos/delete', { id: record._id })
                                                .then((response) => {
                                                    message.success("Eliminado Correctamente")
                                                    this.getAlmacenProductos()
                                                })
                                                .catch((error) => {
                                                    message.error("No es posible eliminar")
                                                    this.getAlmacenProductos();
                                                })
                                            }
                                            okText="Si"
                                            cancelText="No"
                                        >
                                            <Tooltip title="Eliminar">
                                                <Button type="normal" danger icon={<IconDelete />} />
                                            </Tooltip>
                                        </Popconfirm>
                                    </Space>
                                ),
                            },
                        ]}
                    />

                    <FloatingButton title="Nuevo registro" onClick={() => this.setState({ modalAlmacenProducto: true })} />
                </Content>
                <ModalAlmacenProducto
                    id={this.state.producto_id}
                    visible={this.state.modalAlmacenProducto}
                    onCancel={() => {
                        this.setState({ modalAlmacenProducto: false, almacen_producto_id: undefined })
                        this.getAlmacenProductos()
                    }}
                    almacen_id={this.state.almacen_id}
                    inventario_id={this.state.inventario_id}
                    almacen_producto_id={this.state.almacen_producto_id}
                />
            </Spin>
        )
    }
}